const PAGE_CONTAINER_WIDTH = 980;
const PAGE_MARGIN = 60;

export const getBlogPostWidth = ({
  cardWidth,
  cardMargin,
}: {
  cardWidth: number;
  cardMargin: number;
}) => {
  const cardListWidth = PAGE_CONTAINER_WIDTH - PAGE_MARGIN;

  let columnsPerRow = Math.floor(cardListWidth / cardWidth) || 1;
  const gapCount = columnsPerRow - 1;

  if (columnsPerRow * cardWidth + cardMargin * gapCount > cardListWidth) {
    columnsPerRow--;
  }

  const cardSpacing =
    cardListWidth -
    cardWidth * columnsPerRow -
    cardMargin * (columnsPerRow - 1);

  const postWidth = Math.round(
    cardWidth + cardSpacing || 1 / columnsPerRow || 1,
  );

  return postWidth;
};
